import { SubscribeData, SubscribeResponse } from '@/types/subscribe';

export const postSubscribe = async (
  subscribeData: SubscribeData,
): Promise<SubscribeResponse> => {
  const res = await fetch('/api/post-subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(subscribeData),
  });

  const result = await res.json();

  if (!result.success) {
    throw new Error(result.message || 'Failed to submit application.');
  }

  return result;
};
